// extracted by mini-css-extract-plugin
export default {"wrapper":"Ocztgh","button-link":"MZFBKz"};